import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import logo from "../../assets/medal_pdf.png";

const styles = StyleSheet.create({
  titleContainer: {
    width: "100%",
  },
  reportTitle: {
    textAlign: "right",
  },
});

const UniqueId = ({ certificateNo }) => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>{certificateNo}</Text>
  </View>
);

export default UniqueId;
